import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

/**
 * Gates the Documents navbar link and `/documents` page. Defaults OFF.
 * Dietitians can have ALL_PROVIDERS documents — this is not prescriber-only.
 */
export const useProviderAttestationDocuments = (): boolean =>
  useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.PROVIDER_ATTESTATION_DOCUMENTS);
